import React from "react";
import CmsManager from "../CMS/CmsManager";

function InsightList() {
  return (
    <CmsManager
      title="Insights"
      resource="insights"
      supportsReorder
      fields={[
        { name: "title", label: "Insight Title", fullWidth: false },
        { name: "slug", label: "URL Slug", fullWidth: false },
        {
          name: "status",
          label: "Status",
          type: "select",
          defaultValue: "draft",
          fullWidth: false,
          options: [
            { label: "Draft", value: "draft" },
            { label: "Published", value: "published" },
          ],
        },
        { name: "order", label: "Order", type: "number", fullWidth: false },
        { name: "heroImage", label: "Hero Image", type: "image", fullWidth: false },
        { name: "heroImageAlt", label: "Hero Image Alt Tag", fullWidth: false },
        { name: "intro", label: "Page Introduction", type: "intro", showInGrid: false },
        { name: "sections", label: "Page Sections", type: "sections", showInGrid: false },
        { name: "insightCards", label: "Standalone Insight Cards", type: "cards", showInGrid: false },
        {
          name: "faqs",
          label: "Frequently Asked Questions",
          type: "faqs",
          showInGrid: false,
        },
        { name: "content", label: "Additional Rich Text", type: "richtext", showInGrid: false },
        { name: "metaTitle", label: "Title Tag", fullWidth: false },
        { name: "metaDescription", label: "Meta Description", type: "textarea", rows: 3 },
        { name: "metaKeywords", label: "Meta Keywords", type: "keywords", rows: 2 },
      ]}
    />
  );
}

export default InsightList;
